<template>
  <van-popup
      v-model="showPopup"
      round
      class="qr-code-popup"
      :close-on-click-overlay="true"
      @click-overlay="closePopup"
  >
    <div class="popup-content">
      <!-- 关闭按钮移到右上角 -->
      <van-button
          plain
          size="mini"
          type="default"
          class="close-btn"
          @click="closePopup"
      >
        ×
      </van-button>

      <div class="qr-code-container">
        <img :src="qrCodeImage" :alt="$i18n('activityQrCode', '活动二维码')" class="qr-code-image">
      </div>
      <p class="tip-text">{{ $i18n('scanToJoinGroup', '扫码可进入活动群') }}</p>
      <van-button
          size="small"
          type="primary"
          class="download-btn"
          @click="downloadQrCode"
      >
        {{ $i18n('downloadQrCode', '下载二维码') }}
      </van-button>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Button } from 'vant';
import i18nMixin from "@/libs/i18nMixin";

export default {
  mixins: [i18nMixin],
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  props: {
    qrCodeImage: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.show
    };
  },
  watch: {
    show(newVal) {
      this.showPopup = newVal;
    }
  },
  methods: {
    closePopup() {
      this.showPopup = false;
      this.$emit('close');
    },
    downloadQrCode() {
      // 创建下载链接
      const link = document.createElement('a');
      link.href = this.qrCodeImage;
      link.download = this.$i18n('activityQrCodeFile', '活动二维码') + '.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.$emit('download');
    }
  }
};
</script>

<style lang="less" scoped>
.qr-code-popup {
  width: 60%;
  max-width: 280px;
  padding: 15px;
  box-sizing: border-box;
  text-align: center;

  .popup-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .close-btn {
      position: absolute;
      top: -15px;
      right: -15px;
      width: 34px;
      height: 34px;
      min-width: 34px;
      padding: 0;
      border: none;
      font-size: 22px;
      color: #999;
      background: transparent;

      &:active {
        background: rgba(0, 0, 0, 0.05);
      }
    }

    .qr-code-container {
      width: 100%;
      //padding: 8px;
      background: #fff;
      border-radius: 8px;
      //margin: 5px 0;

      .qr-code-image {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .tip-text {
      font-size: 14px;
      color: #666;
      margin: 5px 0 5px;
    }

    .download-btn {
      width: 100%;
      margin-bottom: 5px;
      border-radius: 20px;
      background: linear-gradient(to right, #ff6034, #ee0a24);
      border: none;
    }
  }
}
</style>